var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 8.75c0 2.255-.06 4.022-.117 5.168-.038.781-.794 1.341-1.568 1.237-1.27-.171-3.415-.363-6.648-.363s-5.377.192-6.648.363c-.774.104-1.53-.456-1.568-1.237a107 107 0 0 1-.117-5.168c0-2.255.06-4.021.117-5.168.038-.78.794-1.34 1.568-1.236 1.27.17 3.416.363 6.648.363 3.233 0 5.378-.192 6.648-.363.774-.105 1.53.456 1.568 1.236.056 1.147.117 2.913.117 5.168",
    opacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.659 15.008a27 27 0 0 0-.779 2.075c-.073.227.064.465.3.488.387.038.8.02 1.116-.007.345-.03.647-.227.834-.517.492-.762.969-1.556 1.352-2.213-1.123.04-2.059.103-2.823.174M12.518 14.834c.383.657.86 1.451 1.352 2.213.187.29.49.487.834.517a6.4 6.4 0 0 0 1.116.007c.237-.023.373-.262.3-.488a27 27 0 0 0-.779-2.075c-.764-.07-1.7-.134-2.823-.174"
  })));
};
export default SvgMonitor;